// extracted by css-extract-rspack-plugin
export default {"header":"header-Xzq_C9 -between items-center","title":"title-jHf889 text-display-lg mb-sm","subtitle":"subtitle-ZBn4ua text-body-md"};